export enum DateRangePreset {
  LAST_WEEK = 'last_week',
  LAST_MONTH = 'last_month',
  LAST_THREE_MONTHS = 'last_three_months',
  ALL_TIME = 'all_time',
}
